import React from "react";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Mou from "./components/Mou";
import MouOutcome from "./components/MouOutcome";
import "./App.css";
import Projects from "./components/Projects";
import AddMou from "./components/AddMou";
import Profile from "./components/profile";
import PatentHome from "./components/PatentHome";
import PatentDetails from "./components/PatentDetails";
import PatentForm from "./components/Patent";
import EditPatentForm from "./components/EditPatentForm";
import ViewProject from "./components/ViewProject";
import AddProject from "./components/AddProject";
import EditProject from "./components/EditProject";
import ViewUserProject from "./components/ViewUserProject";
import Publications from "./components/Publications";
import ViewPublications from "./components/ViewPublications";
import AddPublications from "./components/AddPublications";
import DepartmentForm from "./components/DepartmentForm";
import ResearchLabForm from "./components/ResearchLabForm";
import UserForm from "./components/UserForm";
import RoleMasterForm from "./components/RoleMasterForm";
import AssignRole from "./components/AssignRole";
import Settings from "./components/Settings";
import Login from "./components/Login";
import UserTable from "./components/userTable";  
import PublicationsTable from "./components/publicationsTable";
import PublicationDean from "./components/PubliccationDean";
import MouTable from "./components/mouTable";
import ProjectsTable from "./components/projectsTable";
import ReserchTable from "./components/reserchTable";
import PatentTable from "./components/patentTable";
import DepartmentsTable from './components/departmentsTable';
import Publication1 from './components/Publication1';
import Publicationviews from './components/Publicationviews';
import PublicationUserview from "./components/PublicationUserview";
import PublicationDeanEdit from "./components/PublicationDeanEdit";
import EditPublication from "./components/Publicationedit";
import Alertall from "./components/alertall";
import PublicationL from "./components/PublicationList";
import UserSts from "./components/usersts";
import Adminuser from "./components/adminuser";
import MouOutcomes from "./components/mououtcomes";
import ProjectStatusPage from "./components/ProjectStatusPage";
import ViewProjectStatus from "./components/ViewProjectStatus";
import TargetForm from "./components/TargetForm";
import ProjectsFilterPage from "./components/ProjectsFilterPage";
import RabMeetForm from "./components/RabMeetForm";
import DepartmentProjectBarChart from "./components/DepartmentProjectBarChart";
import DeanProjectsStatusPage from "./components/DeanProjectsStatusPage";
import ViewDeanProjectStatus from "./components/ViewDeanProjectStatus";
import ProjectStatusHOD from "./components/ProjectsStatusHOD";
import MOURenewalForm from "./components/MOURenewalForm";
import MOUDetailsTable from "./components/MOUDetailsTable";
import ProjectUCDetails from "./components/Projectuc";
import BeforePublicationView from "./components/BeforePublicationView";
import BeforePublicationViewU from "./components/BeforePublicationViewUser";
import BeforePublicationsList from "./components/BeforePublicationList";
import MyBeforePublications from "./components/BeforePublicationUserList";
import EditBeforePublication from "./components/EditBeforePublication";
import ResearchPaperForm from "./components/BeforePublication";
import SemanticSearch from "./components/SemanticSearch";
import ProjectRevenue from "./components/ProjectRevenue";
import BeforePublicationApprovedView from "./components/BeforePublicationApprovedView";
import EditBeforePublicationfordean from "./components/BeforePublicationforDeanEdit";
import BeforePublicationforDean from "./components/BeforePublicationforDean";

const App = () => {
  return (
    <Router>
      <div className="d-flex flex-column min-vh-100">
        <Navbar className="mb-5" />
        <div className="flex-grow-1">
          <Switch>
            <Route path="/login" exact component={Login} />
            <Route path="/" exact>
              <Redirect to="/login" />
            </Route>
            <Route path="/home" exact component={Home} />
            <Route path="/mou" exact component={Mou} />
            <Route path="/addmou/:mouId" exact component={AddMou} />
            <Route path="/addmou" exact component={AddMou} />
            <Route path="/profile" exact component={Profile} />
            <Route path="/patenthome" exact component={PatentHome} />
            <Route path="/update-patent" exact component={PatentForm} />
            <Route path="/patent-details/:id" exact component={PatentDetails} />
            <Route path="/edit-patent/:id" exact component={EditPatentForm} />
            <Route path="/projects" exact component={Projects} />
            <Route path="/viewproject/:projectId" exact component={ViewProject} />
            <Route path="/addproject" exact component={AddProject} />
            <Route path="/editproject/:projId" exact component={EditProject} />
            <Route path="/viewuserproject/:projectId" exact component={ViewUserProject} />
            <Route path="/viewprojectstatus/:projectId" exact component={ViewProjectStatus} />
            <Route path="/projstatus" exact component={ProjectStatusPage} />
            <Route path="/view/:id" exact component={Publicationviews} />
            <Route path="/Publications1" exact component={Publication1} />
            <Route path="/publications" exact component={PublicationL} />
             <Route path="/beforepubfordean" exact component={BeforePublicationforDean} />
            <Route path="/viewpublications/:pubId" exact component={ViewPublications} />
            <Route path ="/dean/:id" component ={PublicationDeanEdit}/>
            <Route path="/edit/:id" component={EditPublication} />
            <Route path="/addpublications" exact component={AddPublications} />
            <Route path="/pub" exact component={PublicationUserview} />
            <Route path="/deanview" exact component={PublicationDean}/>
            <Route path ="/r" exact component ={ResearchPaperForm}/>
            <Route path="/beforepublications" exact component={ BeforePublicationsList } />
        <Route path="/beforepublication/view/:id" exact component={ BeforePublicationView} />
        <Route path="/my-beforepublications" exact component={MyBeforePublications}/>
        <Route path="/beforepublication/edit/:id" exact component={EditBeforePublication}/>
         <Route path="/beforepublicationforDean/edit/:id" exact component={EditBeforePublicationfordean}/>
        <Route path="/b/view/:id" exact component={BeforePublicationViewU}/>
       <Route path="/beforedeanapproved/view/:id" exact component={BeforePublicationApprovedView}/>
            <Route path="/departments" exact component={DepartmentForm} />
            <Route path="/research-lab" exact component={ResearchLabForm} />
            <Route path="/user" exact component={UserForm} />
            <Route path="/role-master" exact component={RoleMasterForm} />
            <Route path="/assign-role" exact component={AssignRole} />
            <Route path="/settings" exact component={Settings} />
            <Route path="/MouOutcome" exact component={MouOutcome} />
            <Route path="/userTable" exact component={UserTable} />
            <Route path="/mouTable" exact component={MouTable} />
            <Route path="/publicationsTable" exact component={PublicationsTable} />
            <Route path="/projectsTable" exact component={ProjectsTable} />
            <Route path="/reserchTable" exact component={ReserchTable} />
            <Route path="/patentTable" exact component={PatentTable} />
            <Route path="/DepartmentsTable" exact component={DepartmentsTable} />
            <Route path="/Usersts" exact component={UserSts} />
            <Route path="/Adminuser" exact component={Adminuser} />
            <Route path="/MouOutcomes" exact component={MouOutcomes} />
            <Route path="/Alertall" exact component={Alertall} />
            <Route path="/target" exact component={TargetForm} />
            <Route path="/projfilter" exact component={ProjectsFilterPage} />
            <Route path="/rab" exact component={RabMeetForm} />
            <Route path="/dept" exact component={DepartmentProjectBarChart} />
            <Route path="/dstatus" exact component={DeanProjectsStatusPage} />
            <Route path="/viewProjdean/:projectId" exact component={ViewDeanProjectStatus} />
            <Route path="/hodstatus" exact component={ProjectStatusHOD} />
            <Route path="/mou_renewal" exact component={MOURenewalForm}/>
            <Route path="/mou_renewaldata" exact component={MOUDetailsTable}/>
            <Route path="/projectuc" exact component={ProjectUCDetails}/>
            <Route path="/sementic" exact component={SemanticSearch}/>
            <Route path="/projrev" exact component={ProjectRevenue}/> 
            
          </Switch>
        </div>
      </div>
    </Router>
  );
};

export default App;
